import evAPI from '@util/api/ev';
import Papa from 'papaparse';
import { FC, useEffect } from 'react';
import { Text } from './styles';

export interface MLSComplianceDataProps {
  name?: string;
  resoId?: string;
  disclaimer?: string;
  img?: string;
}

const Component: FC<MLSComplianceDataProps> = (props) => {
  (async () => {
    let api = new evAPI();
    let test = await api.locale();
  })();

  useEffect(() => {
    let obj: any[] = [];
    var results = Papa.parse('/assets/MLS_Compliance.csv', {
      download: true,
      // worker: true,
      header: true,
      step: function (row) {
        console.log('Row:', row.data);
        obj.push({
          name: row.data['MLS Name'],
          osn: row.data['OSN'],
          resoId: row.data['RESO ID'],
          disclaimer: row.data['Disclaimer Needed'],
          img: row.data['Logo '],
          imgRequired: row.data['Logo Needed'],
          feedNum: row.data['Feed#'],
          defaultCurrency: row.data['Default Currency'],
        });
      },
      complete: function () {
        console.log('All done!');
        console.log('Object', obj);
      },
    });
  }, []);

  return <Text>{Object.keys(props).join(', ')}</Text>;
};

export default Component;
